import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    Modal,
    ModalHeader,
    ModalBody,
    Label,
    Row,
    Col
} from 'reactstrap';
import { AvFeedback, AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import _ from 'lodash';
import i18n from '../../../i18next';

import {
    loadCategories,
    loadProducts,
    saveProduct,
    publishProduct,
    loadAllergens,
    loadDietaryInfo,
    uploadProductImage,
    loadRestaurantSettings,
    loadNutrients,
    dispatchErrorMessage,
    saveProductCopy,
    isProductCopy,
    isProductEdit
} from "../../../actions";
import { convertCheckBoxValueToBoolean, convertStringToBoolean } from '../../../utils/CommonUtils';
import {
    ALLERGENS,
    US, CA
} from '../../../utils/Constants';
import { posSupportsEditableFreeToppings } from '../../../utils/CommonUtils';
import BatchUpdateConfirmationScreen from './common/batchUpdate/BatchUpdateConfirmationScreen';
import ExtraInfoRows from './ExtraInfoRows';
import SnoozeInputs from './common/SnoozeInputs';
import PopoverCommon from './common/PopoverCommon';
import MenuPartsFooter from './common/MenuPartsFooter';
import AvailabilitySettings from './common/availability/AvailabilitySettings';
import NutrientsList from './common/nutrients/NutrientsList';
import AlergensAndDietaryList from './common/alergensAndDietary/AllergensAndDietaryList';
import MainInformation from './common/MainInformation';
import QuantityFields from './common/additionalInformation/QuantityFields';
import SizeAndCookTimeFields from './common/additionalInformation/SizeAndCookTimeFields';
import TaxFields from './common/additionalInformation/TaxFields';
import ProductImage from './common/additionalInformation/ProductImage';
import { getCroppedImg, createFileFromBase64ImageData } from '../../../utils/CropImageUtils';
import CropImageModal from '../../common/CropImageModal';

class ProductScreen extends Component {
    constructor() {
        super();

        this.state = {
            currentProduct: {
                id: -1,
                name: "",
                active: false,
                description: "",
                minimumQuantity: null,
                maximumQuantity: null,
                sizePriority: "",
                sizeName: "",
                imageUrl: null,
                rectImageUrl: null,
                mealDeal: false,
                origin: "",
                freeToppingsCount: null,
                price: "",
                deposit: null,
                canBePublished: false,
                published: false,
                categoryDraftId: -1,
                multipleActivateOrDeactivate: false,
                multipleNameChange: false,
                multipleDescriptionChange: false,
                multipleSizeChange: false,
                productAvailableAllDay: true,
                cookTime: null,
                allergens: [],
                dietaryInfo: [],
                nutrients: [],
                availableTimes: [],
                productOrderTypes: [],
                disableNotes: false,
                menuDisableNotes: false,
                taxBand: {
                    is: '',
                    taxPercent: ''
                },
                secondaryTaxBand: {
                    id: '',
                    taxPercent: ''
                },
                inactiveUntilTime: null,
                snoozeValue: null,
                originProductId: null,
                availabilityDays: []
            },
            restaurantOrderTypes: [],
            imagePreview: null,
            imageFormData: null,
            additionalInfo: false,
            allergensInfo: true,
            dietaryInfo: true,
            nutrientsInfo: true,
            availabilityInfo: true,
            modalSize: true,
            additionalArrowIcon: true,
            allergensArrowIcon: false,
            dietaryArrowIcon: false,
            nutrientsArrowIcon: false,
            originPopoverOpen: false,
            activePopoverOpen: false,
            disableNotesPopoverOpen: false,
            publishTooltipOpen: false,
            isBatchDeactivateBtnPressed: false,
            showDeleteImageTooltip: false,
            showErrorMsg: false,
            activeType: null,
            cropProductImageModalOpened: false,
            productImageBase64: null,
            imageExtension: null,
            imageFieldValue: '',
            isProductWeekAvailability: true,
            isProductDayAvailability: false,
        }

        this.toggle = this.toggle.bind(this);
        this.changeState = this.changeState.bind(this);
        this.changeNutrientsState = this.changeNutrientsState.bind(this);
        this.changeFreeToppingsCountState = this.changeFreeToppingsCountState.bind(this);
        this.saveProduct = this.saveProduct.bind(this);
        this.toggleOriginPopover = this.toggleOriginPopover.bind(this);
        this.toggleActivePopover = this.toggleActivePopover.bind(this);
        this.toggleDisableNotesPopover = this.toggleDisableNotesPopover.bind(this);
        this.togglePublishTooltip = this.togglePublishTooltip.bind(this);
        this.publishProduct = this.publishProduct.bind(this);
        this.saveCurrentProduct = this.saveCurrentProduct.bind(this);
        this.changeConfirmationType = this.changeConfirmationType.bind(this);
        this.toggleBatchDeactivateConfirmation = this.toggleBatchDeactivateConfirmation.bind(this);
        this.changeProductOperationHours = this.changeProductOperationHours.bind(this);
        this.changeSelectedOrderTypesState = this.changeSelectedOrderTypesState.bind(this);
        this.copyProduct = this.copyProduct.bind(this);
        // Availability binds
        this.updatePrepTimesState = this.updatePrepTimesState.bind(this);
        this.changeSnoozeTime = this.changeSnoozeTime.bind(this);
        this.addOrRemoveItemsInState = this.addOrRemoveItemsInState.bind(this);
        this.changeAvailabilityCustomSelection = this.changeAvailabilityCustomSelection.bind(this);
        this.updateAvailabilityDaysState = this.updateAvailabilityDaysState.bind(this);
    }

    componentDidMount() {
        const restaurantId = this.props.restaurantId;

        this.props.loadAllergens();
        this.props.loadDietaryInfo();
        this.props.loadNutrients();
        this.props.loadRestaurantSettings(restaurantId);

        if (this.props.product.id) {
            this.copyStateFromProps();
        }

        if (this.props.restaurant.posSettings.type.id === 7 && !this.props.product.id) {
            this.setState({
                ...this.state,
                currentProduct: {
                    ...this.state.currentProduct,
                    mealDeal: true
                }
            })
        }
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.product !== this.props.product || prevProps.restaurantOrderTypes !== this.props.restaurantOrderTypes)
            && this.props.product.id) {
            this.copyStateFromProps();
        }
    }

    componentWillUnmount() {
        this.resetModalState();
    }

    copyStateFromProps() {
        const {
            id,
            name,
            active,
            description,
            minimumQuantity,
            maximumQuantity,
            freeToppingsCount,
            sizePriority,
            sizeName,
            imageUrl,
            rectImageUrl,
            mealDeal,
            origin,
            price,
            canBePublished,
            published,
            allergens,
            dietaryInfo,
            nutrients,
            availableTimes,
            productAvailableAllDay,
            taxBand,
            secondaryTaxBand,
            deposit,
            orderTypes,
            cookTime,
            disableNotes,
            menuDisableNotes,
            inactiveUntilTime,
            productId,
            originProductId,
            availabilityDays
        } = this.props.product;
        const { currentProduct } = this.state;

        let modifiedNutrients = [];
        nutrients.map(nutri => {
            let nutriObj = {
                id: nutri.nutrition.id,
                nutritionCode: nutri.nutrition.nutritionCode,
                value: nutri.value
            };

            modifiedNutrients.push(nutriObj);
        });
        
        this.setState({
            currentProduct: {
                id: id ? id : -1,
                name: name ? name : currentProduct.name,
                active: active ? active : currentProduct.active,
                description: description ? description : currentProduct.description,
                minimumQuantity: minimumQuantity ? minimumQuantity : currentProduct.minimumQuantity,
                maximumQuantity: maximumQuantity ? maximumQuantity : currentProduct.maximumQuantity,
                freeToppingsCount: freeToppingsCount ? freeToppingsCount :
                    freeToppingsCount == 0 ? Number(freeToppingsCount) : '',
                sizePriority: sizePriority ? sizePriority : currentProduct.sizePriority,
                sizeName: sizeName,
                imageUrl: imageUrl ? imageUrl : currentProduct.imageUrl,
                rectImageUrl: rectImageUrl ? rectImageUrl : currentProduct.rectImageUrl,
                mealDeal: mealDeal !== undefined ? mealDeal : currentProduct.mealDeal,
                origin: origin ? origin : currentProduct.origin,
                price: price ? price : currentProduct.price,
                canBePublished: canBePublished ? canBePublished : currentProduct.canBePublished,
                published: published ? published : currentProduct.published,
                categoryDraftId: this.props.categoryDraftId,
                currentCategoryDraftId: this.props.categoryDraftId,
                deposit: this.props.posSettings.type.id !== 1 ? deposit : null,
                multipleActivateOrDeactivate: false,
                multipleNameChange: false,
                multipleDescriptionChange: false,
                multipleSizeChange: false,
                allergens: allergens ? allergens : [],
                dietaryInfo: dietaryInfo ? dietaryInfo : [],
                nutrients: modifiedNutrients,
                availableTimes: availableTimes ? availableTimes : [],
                productAvailableAllDay: productAvailableAllDay,                  //if not work correctly --> ? productAvailableAllDay :currentProduct.productAvailableAllDay
                cookTime: cookTime ? cookTime : null,
                taxBand: taxBand ? taxBand : currentProduct.taxBand,
                secondaryTaxBand: secondaryTaxBand ? secondaryTaxBand : currentProduct.secondaryTaxBand,
                productOrderTypes: orderTypes ? orderTypes : currentProduct.productOrderTypes,
                disableNotes: disableNotes || menuDisableNotes ? true : false,
                menuDisableNotes: menuDisableNotes ? menuDisableNotes : false,
                inactiveUntilTime: inactiveUntilTime,
                snoozeValue: null,
                productId,
                originProductId: originProductId ? originProductId : null,
                availabilityDays: availabilityDays ? availabilityDays : []
                // currentCategoryDraftId is used for reloading answers in its group.
                // In the flow categoryDraftId can be changed, that's why we
                // are using questionId in loadProducts action.
            },
            restaurantOrderTypes: this.props.restaurantOrderTypes ? this.props.restaurantOrderTypes : []
        });
    }

    changeProductOperationHours({ target }) {

        this.setState({
            currentProduct: {
                ...this.state.currentProduct,
                productAvailableAllDay: target.value === 'always' ? true : false
            }
        });
    }

    changeAvailabilityCustomSelection(weekAvailability, dayAvailability) {
        if(weekAvailability) {
            this.setState({
                isProductDayAvailability: false,
                isProductWeekAvailability: true
            })
        } else if(dayAvailability) {
            this.setState({
                isProductWeekAvailability: false,
                isProductDayAvailability: true
            })
        }
    }

    changeActiveFlag = e => {
        this.setState({ active: e.target.checked });
    }

    changeFreeToppingsCountState({ target }) {
        this.setState({
            currentProduct: {
                ...this.state.currentProduct,
                [target.name]: target.value
            }
        });
    }

    changeState({ target }) {
        let targetValue = null;
        if (target.value === true || target.value === 'true' || target.value === false || target.value === 'false') {
            targetValue = convertCheckBoxValueToBoolean({ target });
        } else if (target.name === 'taxBand' || target.name === 'secondaryTaxBand') {
            targetValue = {
                id: target.options[target.selectedIndex].id,
                posId: target.options[target.selectedIndex].dataset.posid,
                taxPercent: target.options[target.selectedIndex].dataset.value,
                taxName: target.options[target.selectedIndex].dataset.taxname
            }
            if (!targetValue.taxName) { // not good to be undefined
                targetValue.taxName = null;
            }
        } else {
            targetValue = target.value;
        }

        this.setState({
            currentProduct: {
                ...this.state.currentProduct,
                [target.name]: targetValue
            }
        });
    }

    changeSnoozeTime(dateDiffInMinutes) {
        this.setState({
            ...this.state,
            currentProduct: {
                ...this.state.currentProduct,
                snoozeValue: dateDiffInMinutes
            }
        });
    }

    changeConfirmationType({ target }) {

        this.setState({
            ...this.state,
            currentProduct: {
                ...this.state.currentProduct,
                [target.name]: target.value === 'true' ? true : false
            }
        });
    }

    toggle(saveOrPublish) {
        this.resetModalState();
        this.props.onToggle(this.state.currentProduct, saveOrPublish, "product");
    }

    resetModalState() {
        this.state.currentProduct.id = -1;
        this.state.currentProduct.name = "";
        this.state.currentProduct.active = false;
        this.state.currentProduct.description = "";
        this.state.currentProduct.minimumQuantity = null;
        this.state.currentProduct.maximumQuantity = null;
        this.state.currentProduct.sizePriority = "";
        this.state.currentProduct.sizeName = "";
        this.state.currentProduct.imageUrl = "";
        this.state.currentProduct.rectImageUrl = "";
        this.state.currentProduct.mealDeal = false;
        this.state.currentProduct.origin = "";
        this.state.currentProduct.price = "";
        this.state.currentProduct.canBePublished = false;
        this.state.currentProduct.published = false;
        this.state.currentProduct.allergens = [];
        this.state.currentProduct.dietaryInfo = [];
        this.state.currentProduct.availableTimes = [];
        this.state.currentProduct.availabilityDays = [];
        this.state.restaurantOrderTypes = [];
        this.state.showErrorMsg = false;
        this.state.imagePreview = null;
        this.state.imageFormData = null;
        this.state.currentProduct.taxBand = { taxPercent: 0 };
        this.state.additionalInfo = false;
        this.state.allergensInfo = true;
        this.state.dietaryInfo = true;
        this.state.dietaryInfo = true;
        this.state.availabilityInfo = true;
        this.state.modalSize = true;
        this.state.additionalArrowIcon = true;
        this.state.allergensArrowIcon = false;
        this.state.dietaryArrowIcon = false;
        this.state.restaurantOrderTypes = [];
        this.state.stateAlreadyCopiedFromProps = false;
        this.state.isBatchDeactivateBtnPressed = false;
        this.state.originPopoverOpen = false;
        this.state.activePopoverOpen = false;
        this.state.publishTooltipOpen = false;
        this.state.showDeleteImageTooltip = false;
        this.state.isProductCopy = false;

        this.props.isProductEdit(false);
    }

    saveProduct() {

        if (this.state.currentProduct.id == -1 && this.props.categoryDraftId !== undefined && this.props.categoryDraftId !== -1) {
            this.state.currentProduct.categoryDraftId = this.props.categoryDraftId;
        }

        if (this.state.currentProduct.id === -1 || (this.state.currentProduct.active == this.props.product.active && this.state.currentProduct.name === this.props.product.name &&
            this.state.currentProduct.description === this.props.product.description && this.state.currentProduct.sizeName === this.props.product.sizeName)) {
            this.saveCurrentProduct();
            // this.saveProductAvailability(this.state.currentProduct.productAvailableAllDay);
            return;
        }

        this.toggleBatchDeactivateConfirmation();
    }

    // saveProductAvailability(isAvailable) {
    //     this.setState({
    //         currentProduct: Object.assign({}, this.state.currentProduct, { productAvailableAllDay: isAvailable }),
    //         isCustom: !isAvailable,
    //         isAllDay: isAvailable
    //     });
    // }

    saveCurrentProduct(publishProductCallback) {
        const saveProductCallbackOnSuccess = () => {
            if (!publishProductCallback) {
                this.toggle(true);
            }
        };

        const restaurantId = this.props.restaurantId;
        this.props.saveProduct(this.state.currentProduct, restaurantId, this.state.imageFormData, saveProductCallbackOnSuccess, publishProductCallback);
    }

    publishProduct() {
        const publishProductCallback = () => {
            this.props.publishProduct(this.state.currentProduct);
            this.toggle(true);
        };

        this.saveCurrentProduct(publishProductCallback);
    }

    copyProduct() {
        
        const currentProduct = {...this.state.currentProduct}
        currentProduct.id = -1;
        currentProduct.canBePublished = false;
        currentProduct.imageUrl = null;
        currentProduct.productId = null;
        let modifiedNutrients = [];
        currentProduct.nutrients.map(nutri => {
            let nutriObj = {
                nutrition: {
                    id: nutri.id,
                    nutritionCode: nutri.nutritionCode
                },
                value: nutri.value
            };

            modifiedNutrients.push(nutriObj);
        });
        currentProduct.nutrients = modifiedNutrients;
        currentProduct.orderTypes = currentProduct.productOrderTypes;
        currentProduct.origin = '';
        currentProduct.originProductId = this.state.currentProduct.id;
        
        this.props.saveProductCopy(currentProduct);
        this.toggle(false);
        this.props.isProductCopy(true);
    }

    toggleBatchDeactivateConfirmation() {
        this.setState({
            ...this.state,
            isBatchDeactivateBtnPressed: !this.state.isBatchDeactivateBtnPressed
        });
    }

    togglePublishTooltip() {
        this.setState({
            publishTooltipOpen: !this.state.publishTooltipOpen
        });
    }

    toggleOriginPopover() {
        this.setState({
            originPopoverOpen: !this.state.originPopoverOpen
        });
    }

    renderOriginPopover() {
        const originMsg =
            (this.state.currentProduct.origin !== undefined && this.state.currentProduct.origin !== null
                && this.state.currentProduct.origin !== "") ? this.state.currentProduct.origin : i18n.t('common:popovers.origin');

        const originButton = document.getElementById('origin');
        if (!originButton) return null;

        return (
            <PopoverCommon
                isOpen={this.state.originPopoverOpen}
                target="origin"
                toggle={this.toggleOriginPopover}
                textContent={originMsg}
            />
        );
    }

    toggleActivePopover() {
        this.setState({
            activePopoverOpen: !this.state.activePopoverOpen
        });
    }

    renderActivePopover() {
        return (
            <PopoverCommon
                isOpen={this.state.activePopoverOpen}
                target="active"
                toggle={this.toggleActivePopover}
                textContent={i18n.t('screens:productScreen.activePopover')}
            />
        );
    }

    toggleDisableNotesPopover() {
        this.setState({
            disableNotesPopoverOpen: !this.state.disableNotesPopoverOpen
        });
    }

    negativeDecimalsValidation(e) {
        let inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 43 || inputKeyCode == 45 || inputKeyCode == 69
                || inputKeyCode == 101) e.preventDefault();
        }
    }

    renderDisableNotesPopover() {
        return (
            <PopoverCommon
                isOpen={this.state.disableNotesPopoverOpen}
                target="disableNotes"
                toggle={this.toggleDisableNotesPopover}
                textContent={i18n.t('screens:productScreen.disableNotesPopover')}
            />
        );
    }

    renderMainProductInformation() {
        const { activeGroupStyleRow, activeGroupStyleContainer, activeGroupStyle, activeLabelFreeToppingsCount, freeToppingsCountInputField, activeLabel, cursorPointer } = styles;
        let colSize = 12;
        if (this.state.modalSize === true) {
            if (!this.state.additionalInfo || !this.state.allergensInfo || !this.state.dietaryInfo || !this.state.nutrientsInfo) {
                colSize = 8;
            }

            if (!this.state.availabilityInfo) {
                colSize = 7;
            }
        } else {
            colSize = 12;
        }

        return (
            <Col xs="12" sm={colSize}>
                <MainInformation
                    styles={styles}
                    nameValue={this.state.currentProduct.name}
                    onChange={this.changeState}
                    descriptionValue={this.state.currentProduct.description}
                    draftName={'categoryDraftId'}
                    labelText={i18n.t('screens:productScreen.reassign')}
                    options={this.props.categories}
                    selectValue={this.state.currentProduct.categoryDraftId}
                />
                <Row style={{...activeGroupStyleRow, marginBottom: '20px'}}>
                    <Col xs={12} sm={4} style={activeGroupStyleContainer}>
                        <AvGroup style={{...activeGroupStyle, marginLeft: '10px'}}>
                            <span onClick={this.toggleActivePopover} id="active" style={cursorPointer}>
                                <MaterialIcon icon="help" color="#ff990a" size={20} />
                            </span>
                            {this.renderActivePopover()}
                            <Label style={activeLabel} for="active">{i18n.t('common:buttons.active')}</Label>
                            <AvInput
                                disabled={this.props.restaurant.posSettings.type.id === 7 && !this.state.currentProduct.mealDeal}
                                type="checkbox"
                                name="active"
                                required={false}
                                checked={!!this.state.currentProduct.active}
                                onChange={this.changeState}
                                style={{ margin: '8px 0px 0px 8px' }} />
                        </AvGroup>
                    </Col>
                    <Col xs={12} sm={4} style={activeGroupStyleContainer}>
                        <AvGroup style={{ ...activeGroupStyle}}>
                            <span onClick={this.toggleDisableNotesPopover} id="disableNotes" style={cursorPointer}>
                                <MaterialIcon icon="help" color="#ff990a" size={20} />
                            </span>
                            {this.renderDisableNotesPopover()}
                            <Label style={activeLabel} for="disableNotes">{i18n.t('screens:productScreen.disableNotes')}</Label>
                            <AvInput
                                disabled={this.state.currentProduct.mealDeal || this.state.currentProduct.menuDisableNotes}
                                type="checkbox"
                                name="disableNotes"
                                required={false}
                                checked={!!this.state.currentProduct.disableNotes}
                                onChange={this.changeState}
                                style={{ margin: '8px 0px 0px 8px' }} />
                        </AvGroup>
                    </Col>
                    <Col xs={12} sm={4} style={activeGroupStyleContainer}>
                        <AvGroup style={activeGroupStyle}>
                            <Label for="mealDeal" style={{...activeLabel, marginLeft: 0}}>{i18n.t('screens:productScreen.mealDeal')}</Label>
                            <AvInput type="checkbox" name="mealDeal" disabled={!this.props.posSettings.type.supportCsvFiles}
                                checked={!!this.state.currentProduct.mealDeal}
                                onChange={this.changeState}
                                style={{ margin: '8px 0px 0px 8px' }} />
                        </AvGroup>
                    </Col>
                    {
                        !this.state.currentProduct.active && this.state.currentProduct.id !== -1 ?
                            <SnoozeInputs
                                changeSnoozeTime={this.changeSnoozeTime}
                                currentProduct={this.state.currentProduct}
                                posSettings={this.props.posSettings}
                                restaurant={this.props.restaurant}

                            /> : null
                    }
                    <Col xs={12} sm={4} style={activeGroupStyleContainer}>
                        <AvGroup style={{...activeLabelFreeToppingsCount, position: 'relative'}}>
                            <Label for="freeToppingsCount" style={activeLabel}>{i18n.t('screens:productScreen.freeToppings')}</Label>
                            <AvInput type="number" name="freeToppingsCount"
                                min="0"
                                step="1"
                                disabled={!posSupportsEditableFreeToppings(this.props.posSettings)}
                                required={true}
                                value={this.state.currentProduct.freeToppingsCount}
                                onChange={this.changeFreeToppingsCountState}
                                style={freeToppingsCountInputField} 
                                onKeyPress={(e) => this.negativeDecimalsValidation(e)}/>
                                <AvFeedback style={{position: 'absolute', left: '51%'}}>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                        </AvGroup>
                    </Col>
                    <Col xs={12} sm={4} style={activeGroupStyleContainer}>
                        {
                            this.props.posSettings.type.id !== 1 && !this.props.product.mealDeal &&
                            <AvGroup style={{position: 'relative'}}>
                                <Label for='deposit' style={activeLabel}>{i18n.t('screens:productScreen.deposit')}</Label>
                                <AvInput type="number" name='deposit'
                                    min='0'
                                    required={true}
                                    style={freeToppingsCountInputField}
                                    value={this.state.currentProduct.deposit}
                                    onChange={this.changeState}
                                    onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                                />
                                <AvFeedback style={{position: 'absolute', left: '40%'}}>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                            </AvGroup>
                        }
                    </Col>
                    <Col xs={12} sm={4} style={activeGroupStyleContainer}>
                    {
                        this.props.posSettings.type.supportCsvFiles || this.props.restaurant.posSettings.type.id === 7 ?
                            <AvGroup row style={{ alignItems: 'center', marginLeft: 0, position: 'relative' }} >
                                <Label for='price' style={{ marginBottom: 0 }}>{i18n.t('common:form.price')}</Label>
                                <AvInput style={{ maxWidth: 90, marginLeft: 12, height: 42 }}
                                    id='price' name='price' type='number'
                                    min={0} required={true}
                                    value={this.state.currentProduct.price}
                                    onChange={this.changeState}
                                    onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                                />
                                <AvFeedback style={{position: 'absolute', left: '35%', top: '42px'}}>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                            </AvGroup>
                            : <p name="price">{i18n.t('common:form.price')}: {this.state.currentProduct.price}</p>
                    }
                    </Col>
                </Row>

                <ExtraInfoRows
                    state={this.state}
                    modifyExtraRowsState={(setStateObj) => { this.setState(setStateObj); }}
                    mealDealProduct={this.state.currentProduct.mealDeal} />
            </Col>
        );
    }

    toggleDeleteImageTooltip() {
        this.setState({ ...this.state, showDeleteImageTooltip: !this.state.showDeleteImageTooltip });
    }

    deleteProductImage() {
        const restaurantId = this.props.restaurantId;

        const deleteImageArgument = () => {
            let copyOfProduct = _.cloneDeep(this.state.currentProduct);
            copyOfProduct.imageUrl = null;
            copyOfProduct.rectImageUrl = null;

            this.setState({ ...this.state, currentProduct: copyOfProduct, imagePreview: null, imageFieldValue: '', imageFormData: null });
        };

        this.props.saveProduct(this.state.currentProduct, restaurantId, undefined, undefined, undefined, deleteImageArgument);
    }

    negativeDecimalsValidation(e) {
        let inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 43 || inputKeyCode == 45 || inputKeyCode == 69
                || inputKeyCode == 101) e.preventDefault();
        }
    }

    renderAdditionalProductInformation() {
        const { restaurant } = this.props;

        //check if restaurant data has loaded
        const restCountry = restaurant.id && restaurant.id !== -1 ? restaurant.address.country : '';
        const showSecondaryTax = restCountry === US || restCountry === CA;
        // Check if element is rendered before attaching the tooltip to the element to prevent the dump on render
        const deleteImageButtonElement = document.getElementById('deleteProductImageButton');
        let includeTooltip = false;
        (deleteImageButtonElement) ? includeTooltip = true : includeTooltip = false;

        return (
            <Col xs="12" sm="4" hidden={this.state.additionalInfo}>
                <QuantityFields
                    minimumQuantity={this.state.currentProduct.minimumQuantity}
                    maximumQuantity={this.state.currentProduct.maximumQuantity}
                    changeState={this.changeState}
                    negativeDecimalsValidation={this.negativeDecimalsValidation}
                />
                <SizeAndCookTimeFields
                    sizeName={this.state.currentProduct.sizeName}
                    sizePriority={this.state.currentProduct.sizePriority}
                    changeState={this.changeState}
                    isCookTimeHidden={this.state.currentProduct.mealDeal}
                    cookTime={this.state.currentProduct.cookTime}
                    changeFreeToppingsCountState={this.changeFreeToppingsCountState}
                />
                <TaxFields
                    taxBandId={this.state.currentProduct.taxBand.id}
                    changeState={this.changeState}
                    supportCsvFiles={this.props.posSettings.type.supportCsvFiles}
                    taxPercent={this.state.currentProduct.taxBand.taxPercent}
                    taxBands={this.props.taxBands}
                    showSecondaryTax={showSecondaryTax}
                    secondaryTaxBandId={this.state.currentProduct.secondaryTaxBand.id}
                />
                <ProductImage
                    imagePreview={this.state.imagePreview}
                    currentProduct={this.state.currentProduct}
                    uploadImage={this.uploadImage.bind(this)}
                    deleteProductImage={this.deleteProductImage.bind(this)}
                    includeTooltip={includeTooltip}
                    showDeleteImageTooltip={this.state.showDeleteImageTooltip}
                    toggleDeleteImageTooltip={this.toggleDeleteImageTooltip.bind(this)}
                    imageFieldValue={this.state.imageFieldValue}
                    isLargeImageDesign={this.props.serviceSettingsGeneral.enableLargeImageDesign}
                />
            </Col>
        );
    }

    uploadImage(event) {
        event.preventDefault();
        const file = event.target.files[0];

        if (file.size > 1000000) {
            this.props.dispatchErrorMessage(`${i18n.t('common:validations.maximumImageSize')} 1MB`)
        } else {
            if (file !== undefined) {                           // file === undefined when you click cancel
                this.setState({
                    ...this.state.currentProduct,
                    imagePreview: URL.createObjectURL(file),
                    imageFormData: event.target.files[0],
                    imageFieldValue: event.target.value
                });

                //this is for crop image
                let reader = new FileReader();

                reader.onloadend = () => {
                    this.setState({
                        ...this.state,
                        productImageBase64: reader.result,
                        imageExtension: file.type
                    }, () => this.toggleProductImageCropModal());
                };
                reader.readAsDataURL(file);
            }
        }
    }

    renderAllergensInfo() {

        return (
            <AlergensAndDietaryList
                isHidden={this.state.allergensInfo}
                items={this.props.allergens}
                itemType={ALLERGENS}
                className={"allergens-list-group"}
                product={this.state.currentProduct}
                addOrRemoveItemsInState={this.addOrRemoveItemsInState} />
        );
    }

    addOrRemoveItemsInState(event, allergenOrDietary) {
        let updatedAllergenOrDietary = this.state.currentProduct[allergenOrDietary].slice(0);
        let itemFoundInState = false;
        let itemIndex;
        let currentObject = {
            id: event.target.id,
            value: event.target.name
        }

        if (this.state.currentProduct[allergenOrDietary].length > 0) {
            updatedAllergenOrDietary.map(allergenOrDietaryState => {
                if (Number(event.target.id) === Number(allergenOrDietaryState.id)) {     // Removes item if it is already in state
                    itemFoundInState = true;
                    itemIndex = updatedAllergenOrDietary.indexOf(allergenOrDietaryState);
                    updatedAllergenOrDietary.splice(itemIndex, 1);
                }
            });

            if (!itemFoundInState) {                                                     // Adds item to state
                updatedAllergenOrDietary.push(currentObject);
            }

        } else {
            updatedAllergenOrDietary.push(currentObject);
        }

        this.setState({
            currentProduct: {
                ...this.state.currentProduct,
                [allergenOrDietary]: updatedAllergenOrDietary
            }
        });
    }

    renderDietaryInfo() {

        return (
            <AlergensAndDietaryList
                isHidden={this.state.dietaryInfo}
                items={this.props.dietaryInfo}
                itemType={'dietaryInfo'}
                className={'dietaryTags-list-group'}
                product={this.state.currentProduct}
                addOrRemoveItemsInState={this.addOrRemoveItemsInState} />
        );
    }

    renderNutrients() {

        return (
            <NutrientsList
                {...this.props}
                isHidden={this.state.nutrientsInfo}
                item={this.state.currentProduct}
                changeNutrientsState={this.changeNutrientsState}
            />
        );
    }

    changeNutrientsState(modifiedNutrients) {

        this.setState({
            ...this.state,
            currentProduct: {
                ...this.state.currentProduct,
                nutrients: modifiedNutrients
            }
        });
    }

    changeSelectedOrderTypesState({ target }) {
        let checked = convertStringToBoolean(target.checked);
        const newOrderTypes = this.state.currentProduct.productOrderTypes.slice(0);

        if (checked == true) {
            newOrderTypes.push({
                id: target.id,
                value: target.name
            });
        } else {
            let selectedOrderTypeIndex;

            for (let i = 0; i < newOrderTypes.length; i++) {
                const currentOrderType = newOrderTypes[i];
                if (currentOrderType.id == target.id) {
                    selectedOrderTypeIndex = i;
                    break;
                }
            }

            newOrderTypes.splice(selectedOrderTypeIndex, 1);
        }

        this.setState({
            currentProduct: Object.assign({}, this.state.currentProduct, { productOrderTypes: newOrderTypes })
        });
    }

    updateAvailabilityDaysState(updatedDaysAvailable) {
        this.setState({
            ...this.state,
            currentProduct: {
                ...this.state.currentProduct,
                availabilityDays: updatedDaysAvailable
            },
            showErrorMsg: true
        });
    }

    renderAvailabilityInfo() {

        if (this.state.availabilityInfo) {
            return null;
        }

        return (
            <AvailabilitySettings
                screen={'product'}
                preparationTimes={this.state.currentProduct.availableTimes}
                showErrorMsg={this.state.showErrorMsg}
                state={this.state}
                // Hardcoded value that diferentiates the two different types of the sub component's rendering
                availabilitySettings={true}
                itemAvailableAllDay={this.state.currentProduct.productAvailableAllDay}
                updatePrepTimes={this.updatePrepTimesState}
                changeMenuOperationHours={this.changeProductOperationHours}
                changeSelectedOrderTypesState={this.changeSelectedOrderTypesState}
                isProductDayAvailability={this.state.isProductDayAvailability}
                isProductWeekAvailability={this.state.isProductWeekAvailability}
                changeAvailabilityCustomSelection={this.changeAvailabilityCustomSelection}
                availabilityDays={this.state.currentProduct.availabilityDays}
                updateAvailabilityDaysState={this.updateAvailabilityDaysState}
            />
        );
    }

    updatePrepTimesState(prepTimes, showErrorMsg) {
        this.setState({
            ...this.state,
            currentProduct: {
                ...this.state.currentProduct,
                availableTimes: prepTimes,
            },
            showErrorMsg: true
        });
    }

    renderProductForm() {

        return (
            <AvForm id={-1} className="modalQuestionForm" onValidSubmit={this.saveProduct}>
                <ModalHeader className="modalHeader" toggle={this.toggle}>{i18n.t('screens:productScreen.heading')}</ModalHeader>
                {this.renderModalBody()}
                {this.renderProductInfoFooter()}
            </AvForm>
        );
    }

    renderProductInfoFooter() {
        const { isProductEdit } = this.props.productCopy;
        let posIsNotConfigured = this.props.restaurant ? this.props.restaurant.posStatus === 'NOT_CONFIGURED' : false;
        const isCopyProductButton = isProductEdit && !posIsNotConfigured && this.props.posSettings.type.supportCsvFiles ? true : false;

        return (
            <Fragment>
                <MenuPartsFooter
                    styles={styles}
                    state={this.state}
                    isPublishDisabled={!this.state.currentProduct.canBePublished ? true : false}
                    publishTooltipMsg={i18n.t('screens:productScreen.publishTooltip')}
                    onClickPublish={this.publishProduct}
                    publishTooltipToggle={this.togglePublishTooltip}
                    onClickOrigin={this.toggleOriginPopover}
                    publishedItemId={this.state.currentProduct.productId}
                    onClickCopy={this.copyProduct}
                    isCopyProductButton={isCopyProductButton}
                />
                {this.renderOriginPopover()}
            </Fragment>
        );
    }

    renderModalBody() {

        return (
            <ModalBody>
                <Row>
                    {this.renderMainProductInformation()}
                    {this.renderAdditionalProductInformation()}
                    {/**
                     * TODO 
                     * get the below stuff into a combined container
                     * if time permits it get the one above in onw component and inside the SideInfoContainer
                     */}
                    {this.renderAllergensInfo()}
                    {this.renderDietaryInfo()}
                    {!this.state.currentProduct.mealDeal && this.renderNutrients()}
                    {this.renderAvailabilityInfo()}
                </Row>
            </ModalBody>
        );
    }

    renderBatchDeactivateConfirmationScreen() {

        return (
            <BatchUpdateConfirmationScreen
                screen={'product'}
                isActive={this.state.currentProduct.active}
                isOpen={this.state.isBatchDeactivateBtnPressed}
                onToggle={this.toggle}
                onSave={this.saveCurrentProduct}
                onChange={this.changeConfirmationType}
                statusChanged={this.state.currentProduct.active !== this.props.product.active}
                nameChanged={this.state.currentProduct.name !== this.props.product.name}
                descriptionChanged={this.state.currentProduct.description !== this.props.product.description}
                sizeChanged={this.state.currentProduct.sizeName !== this.props.product.sizeName}
            />
        );
    }

    toggleProductImageCropModal = () => {
        this.setState({
            ...this.state,
            cropProductImageModalOpened: !this.state.cropProductImageModalOpened
        });
    }

    onCropProductImageUpload = async (crop) => {
        try {
            const imageData = await getCroppedImg(crop.image, crop.croppedAreaPixels, 0, this.state.imageExtension);
            const blobData = createFileFromBase64ImageData(imageData, this.state.imageExtension);
            const uploadImageExtension = this.state.imageExtension.split('/')[1];
            const imageFile = new File([blobData], `productImage.${uploadImageExtension}`, { type: blobData.type });

            this.setState({
                ...this.state.currentProduct,
                imagePreview: imageData,
                imageFormData: imageFile
            }, () => this.toggleProductImageCropModal());
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const isLargeImageDesign = this.props.serviceSettingsGeneral.enableLargeImageDesign;
        let modalSize = '';
        if (this.state.modalSize == true && !this.state.saveUnactiveProductPressed && !this.state.saveActiveProductPressed) {
            modalSize = 'lg'
        } else {
            modalSize = 'md'
        }
        
        if (!this.state.isBatchDeactivateBtnPressed) {
            return (
                <div>
                    <Modal isOpen={this.props.isOpen} toggle={this.toggle} size={modalSize} className='productScreen' style={{maxWidth: '1500px'}}>
                        {this.renderProductForm()}
                    </Modal>
                    {
                        this.state.cropProductImageModalOpened ?
                            <CropImageModal
                                isOpen={this.state.cropProductImageModalOpened}
                                onClickSave={this.onCropProductImageUpload}
                                toggle={this.toggleProductImageCropModal}
                                modalClass= {isLargeImageDesign ? 'cropProductLargeImage' : 'cropProductImage'}
                                crop={{
                                    image: this.state.productImageBase64,
                                    crop: { x: 0, y: 0 },
                                    zoom: 1,
                                    cropSize: isLargeImageDesign ? 
                                    { width: 900, height: 600 } :
                                    { width: 500, height: 500 },
                                    croppedAreaPixels: null,
                                }}
                            /> : null
                    }
                </div>
            );
        } else {
            return (
                <div>
                    {this.renderBatchDeactivateConfirmationScreen()}
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        restaurant: state.restaurant,
        categories: state.categories,
        taxBands: state.taxBands,
        allergens: state.allergens,
        dietaryInfo: state.dietaryInfo,
        nutrients: state.nutrients,
        posSettings: state.posSettings,
        restaurantOrderTypes: state.serviceSettingsGeneral.orderTypes,
        productCopy: state.productCopy,
        serviceSettingsGeneral: state.serviceSettingsGeneral,
    }
};

export default connect(mapStateToProps, {
    loadCategories,
    loadProducts,
    saveProduct,
    publishProduct,
    loadAllergens,
    loadDietaryInfo,
    uploadProductImage,
    loadRestaurantSettings,
    loadNutrients,
    dispatchErrorMessage,
    saveProductCopy,
    isProductCopy,
    isProductEdit

})(ProductScreen);

let styles = {
    checkboxInput: {
        position: "relative",
        marginLeft: 10,
        marginRight: 10,
        marginTop: 5
    },
    productAvailabilityRadioBtns: {
        marginLeft: 10,
        marginRight: 10
    },
    screenHeading: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        marginBottom: 20,
        marginLeft: -5,
        paddingLeft: 0
    },
    activeGroupStyleRow: {
        padding: '0 10px'
    },
    activeGroupStyleContainer: {
        display: 'flex',
        alignItems: 'center',
        padding: 0
    },
    activeGroupStyle: {
        width: '100%',
    },
    descriptionStyle: {
        height: 75
    },
    listGroupItem: {
        background: 'none',
        borderBottom: '1px solid #dee2e7',
        cursor: 'pointer',
        borderTop: 'none',
        paddingLeft: '0.2rem',
        paddingRight: 0,
        paddingTop: 0
    },
    marginLeft: {
        marginLeft: 10
    },
    originStyle: {
        color: '#0288d1',
        padding: 0,
        marginRight: 'auto'
    },
    popoverStyle: {
        padding: '12px 6px 0px 6px'
    },
    activeLabel: {
        margin: '2px 0px 3px 8px'
    },
    activeLabelFreeToppingsCount: {
        paddingLeft: 5
    },
    freeToppingsCountInputField: {
        width: 103,
        margin: '0 10px',
        display: 'inline-block'
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    spaceBetween: {
        paddingLeft: 4
    },
    allAndDietFormGroup: {
        height: 465,
        overflow: 'auto',
        marginBottom: 0
    },
    // allAndDietListGroupItem: {
    //     display: 'flex',
    //     justifyContent: 'space-between',
    //     padding: '1px 10px 1px 10px',
    //     marginBottom: 6,
    //     border: 'none',
    //     borderBottom: '1px solid #ced4da',
    //     borderRadius: 0
    // },
    // allAndDietLabel: {
    //     justifyContent: 'flex-start',
    //     width: '90%',
    //     whiteSpace: 'normal'
    // },
    // allAndDietInput: {
    //     width: '10%'
    // },
    inputCounter: {
        textAlign: 'right',
        fontSize: 12,
    }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/ProductScreen.js